import { useEffect, useMemo } from 'react';
import useGlobalContext from "../../context/useGlobalContext";
import useDisplaySnackbar from '../../utils/useDisplaySnackbar';
import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import Datatable from "../../components/Common/Datatable";
import { getColumns, initialSort } from "../Meetings/meetingsTableConfig";
import { AccountViewState, InteractionCounts, MeetingType1, MeetingType2 } from '../../utils/types';
import { getUTCTimeZoneOffset, isDateRange } from '../../utils/utils';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import { getUserAttributes } from '../../utils/auth';
import { UserTeamData } from "../../utils/types";
import ClientService from '../../services/clients/ClientService';
import {convertToUTC} from "../../utils/utils.ts"
import UserInteractionsService from '../../services/interactions/Interactions.ts';

const generateRows = (meetings: any, isTeamMeeting: boolean, newUserTeamData: any,
    parent_page_identifier: any, selectedTab: any, isClientInteraction: boolean, 
    clientDomain: string, isSlideOverOpen?: boolean | undefined, selectedNps?: string | null,
    slideOverParent?: string, activeStat?: string | null, appliedFilters?: Record<string, string>,
     customDateRange?: {startDate: string, endDate: string} | string, clickeduserEmail?: string,
     sort?: { sort_field: string; sort_order: string}, userName?: string, userDetails?: { userEmail: string; userProfileOrgId?: string },
     orgId?: string, subOrgId?: string, clientName?: string, activeView?: string, accountViewState?: AccountViewState
    )=>
    meetings.map((item: any) => ({
        id: item.interactionId,                    // Map `interactionId` to `id`
        title: item.interactionTitle || "",      // Map `interactionTitle` to `summary`
        description: item.interactionDescription || "",  // Map `interactionDescription`
        start_time: item.startTime,                // Map `startTime`
        end_time: item.endTime,                    // Map `endTime`
        duration: item.duration,                   // Map `duration`
        no_of_attendees: item.noOfAttendees,       // Map `noOfAttendees`
        is_external: item.isExternal,              // Map `isExternal`

        attendees: item.attendees || {},           // Map `attendees`
        joinLink: item.joinLink || "",             // Map `joinLink`
        meeting_sentiment: item.overallSentiment || null,         // Map `sentiment`
        rating_source: item.ratingSource || null,  // Map `ratingSource`
        isTeamMeeting: isTeamMeeting,
        newUserTeamData: newUserTeamData,
        parent_page_identifier: parent_page_identifier,
        selectedTab: selectedTab,
        clientDomains: item.clientDomains,
        isClientInteraction: isClientInteraction,
        clientDomain: clientDomain,
        isSlideOverOpen: isSlideOverOpen,
        selectedNps: selectedNps,
        slideOverParent: slideOverParent,
        activeStat: activeStat,
        sentimentSummary: item.sentimentSummary,
        appliedFilters: appliedFilters,
        customDateRange: customDateRange,
        selfTalkTime: item.selfTalkTime,
        actual_duration: item.actualDuration,
        clickeduserEmail: clickeduserEmail,
        sort: sort,        
        userName: userName,
        userDetails: userDetails,
        hasAsset: item.hasAsset,
        orgId: orgId,
        subOrgId: subOrgId,
        clientName: clientName,
        isPresentAsset: item.isPresentAsset,
        isPreviousAsset: item.isPreviousAsset,
        botStatus: item.botStatus,
        activeView: activeView,
        accountViewState: accountViewState,
        momDocLink: item.momDocLink,
    }));

    const ClientMeetings: React.FC<{ clientDomain: string,  startTime?: string;
    endTime?: string; employee_email_ids?: string; parent_page_identifier?: string; 
     selectedUserEmail?: string; newUserTeamData?: UserTeamData | null, selectedTab?: any ,isRated?: boolean,
     setCounts?: React.Dispatch<React.SetStateAction<InteractionCounts>>;
     isSlideOverOpen?: boolean | undefined;
     selectedNps?: string | null;
     slideOverParent?: string; 
     activeStat?: string | null;
     userDetails?: {
        userEmail: string,
        userProfileOrgId?: string,
      }
      selectedUser?: any;
      relationshipType?: string;
      appliedFilters?: Record<string, string>;
      customDateRange?: { startDate: string; endDate: string } | string;
      clickeduserEmail?: string;
      userName?: string,
      orgId?: string | undefined;
      subOrgId?: string | undefined;
      clientName?: string;
      isSpaceMode?: boolean,
      activeView?: string,
      accountViewState?: AccountViewState
     }> = ({
        clientDomain, employee_email_ids, 
        parent_page_identifier, selectedUserEmail, newUserTeamData, selectedTab, isRated, 
        setCounts, isSlideOverOpen, selectedNps, slideOverParent, activeStat, userDetails,
        selectedUser, relationshipType, appliedFilters, customDateRange, clickeduserEmail, userName, orgId, subOrgId, clientName, 
        activeView, accountViewState
    }) => {
    const location = useLocation();
    const [columns] = useState<any[]>(getColumns());
    const [rows, setRows] = useState<any[]>([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const { calendar, startEndTime, timeRange,  startEndMeetingTime, accountDetails, impersonationDetails, featureMap } = useGlobalContext();
    const { showSnackbar } = useDisplaySnackbar();
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const impersonatingUserPorId = impersonationDetails?.impersonatingUserPorId;
    const accessLevel = impersonationDetails?.accessType;
    const isRatingColumnEnabled = featureMap?.enable_rating_column === true;
    const [_filters, setFilters] = useState<{
        date: { start_time: string; end_time: string } | undefined;
        is_external: undefined | boolean;
        group_type: string;
    }>({
        date: undefined,
        is_external: undefined,
        group_type: "",
    });
    const isClientInteraction =
    selectedUser == null &&
    (
        Boolean(location.state?.isClientInteraction) ||
        parent_page_identifier === "client-slideover" ||
        slideOverParent === "account-parent-page"
    );
    const [sort, setSort] = useState(location?.state?.sort != null ? location.state.sort : initialSort);
    const today = new Date();

    const loggedInProfileOrgId = accountDetails?.profileOrgId ?? "";

    const generateStartEndTimes = () => {
        if (slideOverParent === "account-parent-page") {
            return {
            startTime: startEndMeetingTime?.start_time,
            endTime: startEndMeetingTime?.end_time,
            };
        }
        if (isDateRange(customDateRange)) {
            return {
            startTime: customDateRange.startDate,
            endTime: customDateRange.endDate,
            };
        }
        return {
            startTime: startEndMeetingTime.start_time,
            endTime: startEndMeetingTime.end_time,
        };
    };

    const resolvedRange = useMemo(generateStartEndTimes, [
        parent_page_identifier,
        customDateRange,
        slideOverParent,
        timeRange,
        startEndMeetingTime?.start_time,
        startEndMeetingTime?.end_time,
    ]);

    const endOfToday = new Date(today);
    endOfToday.setHours(today.getHours(), today.getMinutes(), 0, 0);
    const startOfThreeMonthsAgo = new Date(today);
    startOfThreeMonthsAgo.setMonth(today.getMonth() - 3);
    startOfThreeMonthsAgo.setHours(0, 0, 0, 0);
    const loggedInEmail = getUserAttributes()?.email;
    const {
        isLoading: isClientInteractionsLoading,
        isFetching: isClientInteractionsFetching,
        isSuccess : isClientInteractionsSuccess,
        isError : isClientInteractionsError,
        error: isClientError,
        data: interactionData,
    } = ClientService.useGetClientInteractions(
        {
            startTime: convertToUTC(resolvedRange.startTime),
            endTime: convertToUTC(resolvedRange.endTime),
            sortBy: sort.sort_field,
            sortOrder: sort.sort_order,
            limit: pageSize,
            offset: pageNumber,
            employeePorId: userDetails?.userProfileOrgId || selectedUser?.employeePorId || loggedInProfileOrgId || selectedUserEmail,
            ...(isRated !== undefined && { isRated }),
            ...(parent_page_identifier !== "account-customer" &&
                parent_page_identifier !== "account-prospect" &&
                parent_page_identifier !== "account-vendor" &&
                parent_page_identifier !== "account-spaces" &&
            userDetails?.userProfileOrgId && {
                analystOrManagerPorId: userDetails.userProfileOrgId,
            }),
            relationshipType: relationshipType || undefined,
            orgId: orgId,
            subOrgId: subOrgId,
            impersonatingPorId: impersonatingUserPorId,
            accessLevel: accessLevel,
            ...(parent_page_identifier === "account-customer" ||
                parent_page_identifier === "account-spaces") && {
                isForOrg: true,
            },
        },
        !!loggedInEmail &&  parent_page_identifier !== "teamInsightsTableConfig"
        &&
        !!resolvedRange.startTime &&
        !!resolvedRange.endTime
    )
    const {
        isLoading: isInteractionsLoading,
        isFetching: isInteractionsFetching,
        isSuccess: isInteractionsSuccess,
        isError: isInteractionsError,
        error: interactionsError,
        data: totalInteractionsData,
      } = UserInteractionsService.useGetUserInteractions(
        {
          startTime: convertToUTC(startEndMeetingTime?.start_time),
          endTime: convertToUTC(startEndMeetingTime?.end_time),
          offset: pageNumber,
          limit: pageSize,
          sortBy: sort.sort_field,
          sortOrder: sort.sort_order,
          isTeamInteraction:  false,
          employeePorId: employee_email_ids && employee_email_ids.length > 0 ? employee_email_ids: "",
          isExternal: false,
        },
            parent_page_identifier === "teamInsightsTableConfig"? true : false
      );
      
      useEffect(()=>{
        setShowSpinner(isInteractionsLoading || isInteractionsFetching);
        if (isInteractionsSuccess) {
            const totalInteractionList = totalInteractionsData?.data || [];
            setTotalRecord(totalInteractionsData?.totalRecords);
            if (totalInteractionList.length > 0) {
                setRows(generateRows(totalInteractionList, true, newUserTeamData, parent_page_identifier, selectedTab,
                     isClientInteraction, clientDomain, isSlideOverOpen, selectedNps, slideOverParent, activeStat, appliedFilters,
                      customDateRange, clickeduserEmail,sort, userName, userDetails, orgId, subOrgId, clientName, activeView, accountViewState));
            }
        }
        if (isInteractionsError) {
            showSnackbar("error", interactionsError || "Failed to fetch client interactions");
            console.error("Error:", isClientError);
        }

      }, [isInteractionsLoading, isInteractionsFetching, interactionsError, isInteractionsSuccess, isInteractionsError])

    useEffect(() => {
        setShowSpinner(isClientInteractionsLoading || isClientInteractionsFetching);
    
        if (isClientInteractionsSuccess) {
            const interactionList = interactionData?.data || [];
            setTotalRecord(interactionData?.totalRecords || 0);  // Set total records
            if (setCounts) {
            setCounts({
                rated: interactionData?.ratedCount ?? 0,
                total: interactionData?.totalCount ?? 0,
                upcomingInteractionId: interactionData?.upcomingInteractionId ?? null,
            });
        }
    
            if (interactionList.length > 0) {
                setRows(generateRows(interactionList, true, newUserTeamData, parent_page_identifier, selectedTab,
                     isClientInteraction, clientDomain, isSlideOverOpen, selectedNps, slideOverParent, activeStat, appliedFilters,
                      customDateRange, clickeduserEmail,sort, userName, userDetails, orgId, subOrgId, clientName, activeView, accountViewState));
            }else{
                setRows([]);
            }
        }
    
        if (isClientInteractionsError) {
            showSnackbar("error", isClientError || "Failed to fetch client interactions");
            console.error("Error:", isClientError);
        }
    }, [
        isClientInteractionsLoading, 
        isClientInteractionsFetching, 
        isClientInteractionsSuccess, 
        isClientInteractionsError, 
        interactionData
    ]);


 useEffect(() => {
    // Generate start and end times based on the selected time range
    const { startTime, endTime } = generateStartEndTimes();

    // If the selected time range is "Today", modify the global context start_time to one year back from today
    if (timeRange === "Today" || timeRange === "today") {
        // Modify global context's start time to one year back
        const oneYearBack = dayjs().subtract(1, 'year').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
        const todayEndTime = dayjs(today).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
        
        // Update global context start time
        startEndTime.start_time = oneYearBack;
        startEndTime.end_time = todayEndTime; // Ensure the end time is set to the end of today
    }

    // Update filters in the local state
    setFilters((prevFilters) => ({
        ...prevFilters,
        date: {
            start_time: startTime,
            end_time: endTime,
        },
    }));
}, [timeRange, startEndTime]);  // Ensure this useEffect triggers when `timeRange` or `startEndTime` changes

    const onPageChange = (value: number) => {
        setPageNumber(value);
    };

    const onPaginationChange = (pageNumber: number) => {
        onPageChange(pageNumber + 1);
    };


    const onFilter = (value: any) => {
        setFilters(value);
        setPageNumber(1);
    };

    const onFilterChange = (columnFilter: any[]) => {
        const filterSelections: {
            date: { start_time: string; end_time: string } | undefined;
            is_external: undefined | boolean;
            group_type: string;
        } = {
            date: undefined,
            is_external: undefined,
            group_type: "",
        };

        columnFilter.forEach((filter) => {
            if (filter.id === "start_time") {
                const utcTimeOffset = getUTCTimeZoneOffset();
                const formattedStartDate = `${dayjs(filter.value).format("YYYY-MM-DD")}T00:00:00${utcTimeOffset}`;
                const formattedEndDate = `${dayjs(filter.value).format("YYYY-MM-DD")}T23:59:59${utcTimeOffset}`;
                filterSelections.date = {
                    start_time: formattedStartDate,
                    end_time: formattedEndDate,
                };
            }
            if (filter.id === "meetingType1") {
                if (filter.value === MeetingType1.Internal)
                    filterSelections.is_external = false;
                if (filter.value === MeetingType1.External)
                    filterSelections.is_external = true;
            }
            if (filter.id === "meetingType2") {
                if (filter.value === MeetingType2.FocusTime)
                    filterSelections.group_type = "focus_time";
                if (filter.value === MeetingType2.OneToOne)
                    filterSelections.group_type = "one_to_one";
                if (filter.value === MeetingType2.Group)
                    filterSelections.group_type = "group";
            }
        });
        onFilter(filterSelections);
    };

    const onSortingChange = (sorting: any[]) => {
        if (sorting && sorting.length > 0)
            setSort({
                sort_field: sorting[0].id,
                sort_order: sorting[0].desc === true ? "desc" : "asc",
            });
    };
    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
      };
    return (
        <>
            <Box
                className="relative flex flex-col justify-start items-start w-full"
                sx={{ gap: "12px" }}
            >
                {showSpinner && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-10">
                    <CircularProgress sx={{ color: "#ccc", opacity: 0.5  }} thickness={5} size={60} />
                </div>
                )}
                <Box className="w-full">
                    <Datatable
                        // header={"Meetings"}
                        columns={columns}
                        rows={rows}
                        rowCount={totalRecord}
                        pageSize={pageSize}
                        initialSort={sort}
                        onPaginationChange={onPaginationChange}
                        onSortingChange={onSortingChange}
                        onFilterChange={onFilterChange}
                        startEndTime={startEndTime}
                        timeRange={timeRange}
                        calendarId={calendar?.calendar_id}
                        onPageSizeChange={(newPageSize: number | null | undefined) => {
                            if (newPageSize !== null && newPageSize !== undefined) {
                              handlePageSizeChange(newPageSize);
                            }
                        }}
                        columnVisibility={{is_manager: false, talkTrack: false, duration: false, sharedDate: false,
                             rating_source : false, abstractiveScore: false, shareIcon: false,
                            meeting_sentiment: isRatingColumnEnabled ? true : false,
                            account: false, opportunityName: false}}
                        minHeight="calc(100vh - 315px)"
            
                    />
                </Box>
            </Box>
        </>
    );
};

export default ClientMeetings;
